export default (options) => {
  return {
    applyHtmlTags: ['ul'].map(tag => tag.toLowerCase())
  }
}
